const TAB_IDS = ['tools', 'rules', 'sales'];

function setToolRentalTab(root, tabId, updateHash = true) {
    if (!TAB_IDS.includes(tabId)) return;

    root.querySelectorAll('[data-tool-rental-tab]').forEach((tabButton) => {
        const isActive = tabButton.dataset.toolRentalTab === tabId;
        tabButton.classList.toggle('tool-rental__tab--active', isActive);
        tabButton.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    root.querySelectorAll('[data-tool-rental-panel]').forEach((panel) => {
        const isActive = panel.dataset.toolRentalPanel === tabId;
        panel.classList.toggle('tool-rental__panel--active', isActive);
        panel.hidden = !isActive;
    });

    if (updateHash) {
        const url = new URL(window.location.href);
        url.searchParams.set('tab', tabId);
        window.history.replaceState(null, '', url);
    }
}

function getTabFromHash() {
    const hash = window.location.hash.replace('#', '');
    return TAB_IDS.includes(hash) ? hash : null;
}

function getTabFromQuery() {
    const tab = new URLSearchParams(window.location.search).get('tab');
    return TAB_IDS.includes(tab) ? tab : null;
}

export function initToolRentalTabs() {
    const root = document.querySelector('[data-tool-rental-tabs]');
    if (!root) return;

    const defaultTab = root.dataset.toolRentalDefaultTab || 'rules';
    const initialTab = getTabFromHash() || getTabFromQuery() || defaultTab;

    setToolRentalTab(root, initialTab, false);

    root.querySelectorAll('[data-tool-rental-tab]').forEach((tabButton) => {
        tabButton.addEventListener('click', () => {
            setToolRentalTab(root, tabButton.dataset.toolRentalTab);
        });
    });

    window.addEventListener('hashchange', () => {
        const tabId = getTabFromHash();
        if (tabId) {
            setToolRentalTab(root, tabId, false);
        }
    });

    root.querySelectorAll('[data-tool-rental-accordion-head]').forEach((head) => {
        head.addEventListener('click', () => {
            if (head.disabled) return;

            const bodyId = head.getAttribute('aria-controls');
            const body = bodyId ? document.getElementById(bodyId) : null;
            if (!body) return;

            const isExpanded = head.getAttribute('aria-expanded') === 'true';
            const nextExpanded = !isExpanded;
            head.setAttribute('aria-expanded', nextExpanded ? 'true' : 'false');
            body.hidden = !nextExpanded;

            const item = head.closest('.tool-rental__accordion-item');
            if (item) {
                item.classList.toggle('tool-rental__accordion-item--open', nextExpanded);
            }
        });
    });
}
